import gql from 'graphql-tag';

export const programByCampus = gql`
  query programByCampus($campusId: String!, $periodId: String!) {
    procedures {
      programByCampus(campusId: $campusId, periodId: $periodId) {
        id
        name
        modalities {
          id
          name
          codProgram
          codPlan
          reincorporationType
          acadCareer
          codProgCM
          codPlanCM
          acadCareerCM
        }
      }
    }
  }
`;

export const registerReincorporation = gql`
  mutation registerReincorporation(
    $procedureId: Float!
    $newPeriod: String!
    $requiresPayment: Boolean!
    $campusId: String!
    $careerId: String!
    $modalityId: String!
    $newCampusId: String!
    $newCampusDescription: String!
    $newCareerId: String!
    $newCareerDescription: String!
    $newModalityId: String!
    $newModalityDescription: String!
    $reincorporationType: String!
    $academicPlan: String!
    $careerPS: String!
    $codProgCM: String!
    $codPlanCM: String!
    $acadCareerCM: String!
  ) {
    registerReincorporation(
      request: {
        procedureId: $procedureId
        newPeriod: $newPeriod
        requiresPayment: $requiresPayment
        campusId: $campusId
        careerId: $careerId
        modalityId: $modalityId
        newCampusId: $newCampusId
        newCampusDescription: $newCampusDescription
        newCareerId: $newCareerId
        newCareerDescription: $newCareerDescription
        newModalityId: $newModalityId
        newModalityDescription: $newModalityDescription
        reincorporationType: $reincorporationType
        academicPlan: $academicPlan
        careerPS: $careerPS
        codProgCM: $codProgCM
        codPlanCM: $codPlanCM
        acadCareerCM: $acadCareerCM
      }
    ) {
      error
      requestId
    }
  }
`;

export const activatePaymentReincorporation = gql`
  mutation activatePaymentReincorporation($requestId: Float!) {
    activatePaymentReincorporation(requestId: $requestId) {
      error
      requestId
    }
  }
`;
